// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1ebc2eb5","455":"f385aa6f","488":"2d05aae2","977":"888a7361"}[chunkId] + ".chunk.js";
};